import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import styles from './ACDialog.module.scss';

export default class ACDialog extends React.Component {
  render() {
    const {
      heading = '',
      body = [],
      isOpen,
      okButtonLabel = '',
      cancelButtonLabel = '',
      onClickCancelFunc,
      onCloseFunc,
      onClickOkFunc,
    } = this.props;

    return (
      <div>
        <Dialog
          classes={{
            paper: styles.acDialog,
          }}
          open={isOpen}
          onClose={onCloseFunc}
        >
          <DialogTitle>{heading}</DialogTitle>
          <DialogContent>
            {body.map((b) => {
              return <DialogContentText>{b}</DialogContentText>;
            })}
          </DialogContent>
          <DialogActions>
            {okButtonLabel && (
              <Button
                variant="contained"
                style={{ color: 'white' }}
                autoFocus
                onClick={onClickOkFunc}
                color="primary"
              >
                {okButtonLabel}
              </Button>
            )}
            {cancelButtonLabel && (
              <Button
                variant="contained"
                style={{ color: 'white' }}
                onClick={onClickCancelFunc}
                color="secondary"
              >
                {cancelButtonLabel}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
